module.exports = __webpack_public_path__ + "static/media/portal-umais-logo-pdf.43a156a9.png";